export const SET_ACTIVE_DISTRIBUTOR = 'SET_ACTIVE_DISTRIBUTOR'
export const SET_ACTIVE_DISTRIBUTOR_UNBINDED_COUNTERS = 'SET_ACTIVE_DISTRIBUTOR_UNREAD_COUNTERS'
export const SET_BACKGROUND_TASKS = 'SET_BACKGROUND_TASKS'
export const SET_BACKGROUND_TASKS_FETCHING = 'SET_BACKGROUND_TASKS_FETCHING'
